import React from 'react';

const PasswordSentRequestForm = () => {
    return (
        <React.Fragment>
            <h1>Your request was received</h1>
            <div>
                <p className={"loginStatement"}>
                    You will receive an email shortly to complete the password reset process.
                </p>
            </div>
        </React.Fragment>
    )
}

export default PasswordSentRequestForm